const fallback = '"Segoe UI", "Droid Sans", Roboto, Helvetica, Arial, sans-serif';
// CJK fallback for :lang(zh) — system fonts that cover Chinese glyphs so missing Noto Sans SC chars don't render as tofu.
const cjkFallback = '"PingFang SC", "Microsoft YaHei", "Hiragino Sans GB", system-ui, sans-serif';

export default {
    gtStandardLSemibold: `GT Standard L Semibold, ${fallback}`,
    gtStandardLBold: `GT Standard L Bold, ${fallback}`,
    gtStandardMMedium: `GT Standard M Medium, ${fallback}`,
    gtStandardMBold: `GT Standard M Bold, ${fallback}`,
    gtStandardSSemibold: `GT Standard S Semibold, ${fallback}`,
    gtAmericaRegular: `GT America LC Regular, ${fallback}`,
    gtAmericaSemibold: `GT America LC Semibold, ${fallback}`,
    gtAmericaBold: `GT America LC Bold, ${fallback}`,

    // :lang(zh) — Chinese (zh-CN, zh-TW, zh-HK)
    notoSansSCRegular: `Noto Sans SC Regular, ${cjkFallback}`,
    notoSansSCBold: `Noto Sans SC Bold, ${cjkFallback}`,
};
